import React, { useState } from "react";
import {
  
  Button,
  Label,
  Input,
  FormGroup,
  Form,
  Modal,
  FormFeedback,
  ModalHeader,
  ModalBody,
  ModalFooter,
  
  Tooltip,
} from "reactstrap";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import API from "../../../redux/actions/API";
import { PAY_PUP_LS_TEMPLATE_ID } from "../../../constants/LocalStorageVariables";
import {
  CREATE_LICENSE_TEMPLATE,
} from "../../../constants/ApiPaths";
import { getAdminUserId, getAgencyId } from "../../common/CommonFunctions";
import { CustomAlertMessage } from "../../../functions/CustomFunctions";
import { useSnackbar } from "notistack";
import CustomButtonLoader from "../../CustomComponents/CustomButtonLoader";
import { AGENCY_CREATE_TEMPLATE } from "../../../constants/RoutePaths";
import { Info } from "../../common/Info";
import { authHeader } from "../../../functions/CoreFunctions";

export default function AgencyTemplatecreatemodel(props) {
  const { toggle, modal, reCall, formData, setReCall, className, isAgency } = props;
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const history = useNavigate();
  const validationSchema = Yup.object().shape({
    licenseName: Yup.string().required("License Name is Required"),
    licenseDescription: Yup.string().required(
      "License Description is Required"
    ),
     isOnlinePayment: Yup.boolean(),
     isOfflinePayment: Yup.boolean().test(
    "at-least-one-payment-mode",
    "Select payment mode",
    function (value) {
      const { isOnlinePayment } = this.parent;
      return value || isOnlinePayment;
    }
  ),
});

  const [id, setid] = useState("");
  const [tooltipOpen, setTooltipOpen] = useState(false);

  const tooltiptoggle = (id) => {
    setid(id);
    setTooltipOpen(!tooltipOpen);
  };
  const {
    handleSubmit,
    handleChange,
    values,
    handleBlur,
    resetForm,
    errors,
    touched,
  } = useFormik({
    initialValues: formData,
    enableReinitialize: true,
    validationSchema,
    onSubmit: (values) => CreateLicenseTemplate(values),
  });

  const CreateLicenseTemplate = async () => {
    setLoading(true);
    const config = {
      method: "POST",
      url: CREATE_LICENSE_TEMPLATE,
      headers: authHeader(),

      data: { ...values, agencyId: getAgencyId(), createdBy: getAdminUserId(), isAgencyLicense: isAgency ? true : false
       },
    };
    try {
      const response = await API(config);
      const { status, templateId } = response.data;

      if (status === "Success") {
        localStorage.setItem(PAY_PUP_LS_TEMPLATE_ID, templateId);
        resetForm({});
        toggle();
        setReCall(reCall + 1);
        CustomAlertMessage(
          "Template Created Successfully",
          "success",
          enqueueSnackbar
        );
        history(`${AGENCY_CREATE_TEMPLATE}/${templateId}`);
      }
    } catch (error) {
      if (error.response) {
        const { data } = error.response;
        CustomAlertMessage(data.message, "error", enqueueSnackbar);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal centered={true} isOpen={modal} toggle={toggle} className={className}>
      <Form form="true" onSubmit={handleSubmit}>
        <ModalHeader toggle={toggle}>
          New License Template{" "}
          <Tooltip
            isOpen={id === "templatecreate" && tooltipOpen}
            target={"templatecreate"}
            toggle={() => tooltiptoggle("templatecreate")}
          >
            Create new license template
          </Tooltip>
          <span id={"templatecreate"}>
            <Info />
          </span>
        </ModalHeader>
        <ModalBody>
          <FormGroup>
            <Label for="">License Name</Label>
            <Input
              type="text"
              onBlur={handleBlur}
              values={values.licenseName}
              invalid={errors.licenseName && touched.licenseName ? true : false}
              onChange={handleChange}
              name="licenseName"
              id=""
              placeholder="Enter License Name"
            />
            <FormFeedback>
              {errors.licenseName && touched.licenseName
                ? errors.licenseName
                : ""}
            </FormFeedback>
          </FormGroup>
          <FormGroup>
            <Label for="">License Description</Label>
            <Input
              type="text"
              onBlur={handleBlur}
              values={values.licenseDescription}
              invalid={
                errors.licenseDescription && touched.licenseDescription
                  ? true
                  : false
              }
              onChange={handleChange}
              name="licenseDescription"
              id=""
              placeholder="Enter License Description"
            />
            <FormFeedback>
              {errors.licenseDescription && touched.licenseDescription
                ? errors.licenseDescription
                : ""}
            </FormFeedback>
          </FormGroup>
            <FormGroup>
            <Label>Payment Type</Label>
            
            <FormGroup check>
              <Label check>
                <Input
                  type="checkbox"
                  name="isOnlinePayment"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  checked={values.isOnlinePayment}
                  invalid={errors.isOnlinePayment && touched.isOnlinePayment}
                />
                Online card payment
              </Label>
            </FormGroup>

            <FormGroup check>
              <Label check>
                <Input
                  type="checkbox"
                  name="isOfflinePayment"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  checked={values.isOfflinePayment}
                  // invalid={errors.isOfflinePayment && touched.isOfflinePayment}
                />
                Offline Payment with Agency
              </Label>
              
            </FormGroup>
                  {/* {errors.isOfflinePayment && (
                <div className="text-danger mt-1" style={{fontSize: '14px'}}>
                  {errors.isOfflinePayment}
                </div>
              )} */}
              {(touched.isOfflinePayment || touched.isOnlinePayment) && errors.isOfflinePayment && (
                <div className="text-danger" style={{fontSize: '14px'}}>{errors.isOfflinePayment}</div>
              )}
              {/* <FormFeedback>
                 {(values.touched.isOfflinePayment || values.touched.isOnlinePayment) &&
                    values.errors.isOfflinePayment
                      ? values.errors.isOfflinePayment
                      : ""} */}
                  {/* </FormFeedback> */}
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button type="submit" color="primary">
            {loading && <CustomButtonLoader />}
            Submit
          </Button>
          <Button color="danger" onClick={toggle}>
            Close
          </Button>
        </ModalFooter>
      </Form>
    </Modal>
  );
}
